import { Directive, HostListener, ElementRef } from "@angular/core";
import { NgControl } from "@angular/forms";

@Directive({
  selector: "[appInputTextUppercase]",
})
export class InputTextUppercaseDirective {
  constructor(
    private ngControl: NgControl,
    private el: ElementRef,
  ) {}

  @HostListener("input", ["$event"])
  onInput(event: InputEvent) {
    const input = this.el.nativeElement as HTMLTextAreaElement;
    const start = input.selectionStart;
    const end = input.selectionEnd;

    const originalValue = input.value;
    const upperValue = originalValue.toUpperCase();

    if (originalValue !== upperValue) {
      // 1. Update the Form Control value (This fixes your HTML log)
      this.ngControl.control?.setValue(upperValue, {
        emitEvent: false,
      });

      // 2. Force the UI element to match the uppercase value
      input.value = upperValue;

      // 3. Keep the cursor from jumping to the end
      input.setSelectionRange(start, end);

      // 4. Trigger validation so the regex sees the Uppercase 'S'
      this.ngControl.control?.updateValueAndValidity();
    }
  }
}
